'use client';
import { Props as BeautyStoreNewsletterUnsubscribeProps } from './beauty-store-newsletter-unsubscribe.component';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import dynamic from 'next/dynamic';

const DynamicBeautyStoreNewsletterUnsubscribeComponent: ComponentType<BeautyStoreNewsletterUnsubscribeProps> =
  dynamic(() => import('./beauty-store-newsletter-unsubscribe.component'));

export default DynamicBeautyStoreNewsletterUnsubscribeComponent;

export function calculateBeautyStoreNewsletterUnsubscribePlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 210 },
    { sinceWidth: 768, height: 250 },
    { sinceWidth: 1024, height: 250 }
  ];
  return { heightSinceWidth };
}
